(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brizeeo-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('brizeeo-product')) {
    customElements.define(
      'brizeeo-product',
      class extends HTMLElement {
        connectedCallback() {
          this.variants = JSON.parse(this.querySelector('[data-product-variants]')?.textContent || '[]');
          this.selectedOptions = [];
          this.querySelectorAll('[data-option-group]').forEach((group, index) => {
            const selected = group.querySelector('.is-selected');
            const select = group.querySelector('[data-option-select]');
            this.selectedOptions[index] = select?.value || selected?.dataset.optionValue || '';
          });

          this.querySelectorAll('[data-option-value]').forEach((button) => {
            button.addEventListener('click', () => this.selectOption(button));
          });

          this.querySelectorAll('[data-option-select]').forEach((select) => {
            select.addEventListener('change', () => this.selectDropdown(select));
          });

          this.querySelectorAll('[data-thumbnail]').forEach((button) => {
            button.addEventListener('click', () => this.showMedia(Number(button.dataset.thumbnail)));
          });

          const track = this.querySelector('[data-gallery-track]');
          track?.addEventListener('scroll', () => {
            const index = Math.round(track.scrollLeft / track.clientWidth);
            this.setActiveThumb(index);
          }, { passive: true });
        }

        selectOption(button) {
          const index = Number(button.dataset.optionIndex);
          this.selectedOptions[index] = button.dataset.optionValue;
          this.querySelectorAll(`[data-option-index="${index}"]`).forEach((item) => {
            const selected = item === button;
            item.classList.toggle('is-selected', selected);
            item.setAttribute('aria-pressed', String(selected));
          });
          const label = this.querySelector(`[data-option-label="${index}"]`);
          if (label) label.textContent = button.dataset.optionValue;
          this.updateVariant();
        }

        selectDropdown(select) {
          const index = Number(select.dataset.optionIndex);
          this.selectedOptions[index] = select.value;
          const label = this.querySelector(`[data-option-label="${index}"]`);
          if (label) label.textContent = select.value;
          this.updateVariant();
        }

        updateVariant() {
          const variant = this.variants.find((item) =>
            item.options.every((value, index) => value === this.selectedOptions[index])
          );
          const input = this.querySelector('[data-variant-input]');
          const addButton = this.querySelector('[ref="addToCartButton"]');
          const addText = this.querySelector('[data-add-text]');
          const stock = this.querySelector('[data-stock-message]');

          if (!variant) {
            addButton.disabled = true;
            addText.textContent = this.dataset.labelUnavailable;
            stock.lastChild.textContent = this.dataset.labelUnavailable;
            stock.classList.add('is-unavailable');
            return;
          }

          input.value = variant.id;
          input.dispatchEvent(new Event('change', { bubbles: true }));
          addButton.disabled = !variant.available;
          addText.textContent = variant.available ? this.dataset.labelAdd : this.dataset.labelSoldOut;
          stock.lastChild.textContent = variant.available ? 'In stock' : this.dataset.labelSoldOut;
          stock.classList.toggle('is-unavailable', !variant.available);
          this.querySelector('[data-price]').textContent = this.formatMoney(variant.price);

          const compare = this.querySelector('[data-compare-price]');
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            compare.hidden = false;
            compare.textContent = this.formatMoney(variant.compare_at_price);
          } else {
            compare.hidden = true;
          }

          if (variant.featured_media?.id) {
            const slides = [...this.querySelectorAll('[data-media-id]')];
            const index = slides.findIndex((slide) => Number(slide.dataset.mediaId) === variant.featured_media.id);
            if (index >= 0) this.showMedia(index);
          }

          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url);
        }

        showMedia(index) {
          const track = this.querySelector('[data-gallery-track]');
          const slide = track?.children[index];
          slide?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
          this.setActiveThumb(index);
        }

        setActiveThumb(index) {
          this.querySelectorAll('[data-thumbnail]').forEach((thumb, thumbIndex) => {
            thumb.classList.toggle('is-active', thumbIndex === index);
          });
        }

        formatMoney(cents) {
          return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
            style: 'currency',
            currency: this.dataset.currency || 'EUR',
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
          }).format(cents / 100);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brizeoo-product-community"] && !Shopify.designMode) return;
  try {
    
  const initializeCommunityRails = (scope = document) => {
    scope.querySelectorAll('[data-community-rail]').forEach((rail) => {
      if (rail.dataset.autoScrollReady === 'true') return;
      rail.dataset.autoScrollReady = 'true';

      const originals = [...rail.children];
      if (originals.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      originals.forEach((item) => {
        const clone = item.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('img').forEach((image) => { image.alt = ''; });
        rail.appendChild(clone);
      });

      let paused = false;
      let frame;
      let previousTime;

      const cycleWidth = () => {
        const first = originals[0];
        const duplicate = rail.children[originals.length];
        return duplicate.offsetLeft - first.offsetLeft;
      };

      const animate = (time) => {
        if (!previousTime) previousTime = time;
        if (!paused) {
          rail.scrollLeft += (time - previousTime) * 0.025;
          const width = cycleWidth();
          if (width > 0 && rail.scrollLeft >= width) rail.scrollLeft -= width;
        }
        previousTime = time;
        frame = requestAnimationFrame(animate);
      };

      const pause = () => { paused = true; };
      const resume = () => { paused = false; previousTime = performance.now(); };

      rail.addEventListener('mouseenter', pause);
      rail.addEventListener('mouseleave', resume);
      rail.addEventListener('focusin', pause);
      rail.addEventListener('focusout', resume);
      rail.addEventListener('pointerdown', pause);
      rail.addEventListener('pointerup', resume);
      rail.addEventListener('pointercancel', resume);
      rail.addEventListener('touchstart', pause, { passive: true });
      rail.addEventListener('touchend', resume, { passive: true });

      frame = requestAnimationFrame(animate);
      rail.addEventListener('shopify:section:unload', () => cancelAnimationFrame(frame), { once: true });
    });
  };

  initializeCommunityRails();
  document.addEventListener('shopify:section:load', (event) => initializeCommunityRails(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brizeoo-product-reviews"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.ml-reviews').forEach((section) => {
    const button = section.querySelector('.ml-reviews__more');
    button?.addEventListener('click', () => {
      const hidden = [...section.querySelectorAll('.ml-review--extra[hidden]')];
      hidden.slice(0, 3).forEach((review) => { review.hidden = false; });
      button.setAttribute('aria-expanded', 'true');
      if (hidden.length <= 3) button.hidden = true;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brizeoo-recently-viewed"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('recently-viewed-products')) {
    customElements.define('recently-viewed-products', class extends HTMLElement {
      async connectedCallback() {
        const current = this.dataset.currentHandle;
        const key = 'brizeoo-recent-products';
        let handles = [];
        try { handles = JSON.parse(localStorage.getItem(key) || '[]'); } catch (error) { handles = []; }
        const previous = handles.filter((handle) => handle && handle !== current).slice(0, 4);
        localStorage.setItem(key, JSON.stringify([current, ...previous].slice(0, 5)));
        if (!previous.length) return;
        const products = (await Promise.all(previous.map(async (handle) => {
          try { const response = await fetch(`/products/${handle}.js`); return response.ok ? response.json() : null; } catch (error) { return null; }
        }))).filter(Boolean);
        if (!products.length) return;
        const grid = this.querySelector('[data-recent-grid]');
        products.forEach((item) => {
          const link = document.createElement('a');
          link.className = 'bp-recent__card';
          link.href = item.url;
          const image = item.featured_image ? `<img src="${item.featured_image}" alt="" loading="lazy">` : '';
          const price = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: this.dataset.currency || 'GBP' }).format(item.price / 100);
          link.innerHTML = `${image}<strong></strong><span>${price}</span>`;
          link.querySelector('strong').textContent = item.title;
          const productImage = link.querySelector('img');
          if (productImage) productImage.alt = item.title;
          grid.appendChild(link);
        });
        this.hidden = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
